import axios from "axios";
import dayjs from "dayjs";
import { Initial, LodgingOffersEvents } from "redmond";
import {
  IOfferAvailabilityRequest,
  LodgingCollectionEnum,
} from "redmond/hotels-module/interfaces";
import { config } from "../../config";
import { lodgingOffersAvailabilityApiPrefix } from "../paths";
import { trackEvent } from "../analytics/trackEvent";

export const fetchPremiumCollectionOffersAvailability = async (
  body: IOfferAvailabilityRequest
): Promise<Initial> => {
  const startTime = dayjs();
  const res = await axios.post(lodgingOffersAvailabilityApiPrefix, body, {
    baseURL: config.baseURL,
  });
  trackEvent({
    eventName:
      body.lodgingCollection === LodgingCollectionEnum.Premier
        ? LodgingOffersEvents.VIEWED_PC_OFFERS_AVAILABILITY_LOADING
        : LodgingOffersEvents.VIEWED_LC_OFFERS_AVAILABILITY_LOADING,
    properties: {
      runtime: dayjs().diff(startTime, "seconds", true),
    },
  });
  return res.data;
};
